(function () {
  import("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs").then(
    (_ref) => {
      let { Swiper, Navigation } = _ref;
      const wrapper = document.querySelector(".image-scroll__wrapper");
      const loop = wrapper.dataset.loop === "true" ? true : false;
      Swiper.use([Navigation]);
      const swipperFeatured = new Swiper(".image-scroll__swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: loop,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: ".image-scroll__swiper-button-next",
          prevEl: ".image-scroll__swiper-button-prev",
        },
      });
    }
  );
})();
